/**
 * @generated SignedSource<<0821a915668cfc66b4c4565f3c38c938>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationAccountName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationEmail"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emailSubject"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forwardingEmail"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v9 = [
  {
    "kind": "Variable",
    "name": "commtype",
    "variableName": "commType"
  },
  {
    "kind": "Variable",
    "name": "destinationaccountname",
    "variableName": "destinationAccountName"
  },
  {
    "kind": "Variable",
    "name": "destinationemail",
    "variableName": "destinationEmail"
  },
  {
    "kind": "Variable",
    "name": "emailsubject",
    "variableName": "emailSubject"
  },
  {
    "kind": "Variable",
    "name": "endts",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "forwardingemail",
    "variableName": "forwardingEmail"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "startts",
    "variableName": "startDate"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunicationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CommtEntriesConnection",
        "kind": "LinkedField",
        "name": "communicationssearch",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommunicationsList_al"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommunicationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "CommtEntriesConnection",
        "kind": "LinkedField",
        "name": "communicationssearch",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CommtEntry",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationAccountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationAccountName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationFirstname",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationLastname",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendingAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendingAppId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAppId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forwardingEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commSubject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentTime",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01d08e23239a8a263001c45d70191bb5",
    "id": null,
    "metadata": {},
    "name": "CommunicationsQuery",
    "operationKind": "query",
    "text": "query CommunicationsQuery(\n  $startDate: Datetime\n  $endDate: Datetime\n  $emailSubject: String\n  $destinationAccountName: String\n  $destinationEmail: String\n  $forwardingEmail: String\n  $commType: Int\n  $first: Int\n  $offset: Int\n) {\n  communicationssearch(startts: $startDate, endts: $endDate, emailsubject: $emailSubject, destinationaccountname: $destinationAccountName, destinationemail: $destinationEmail, forwardingemail: $forwardingEmail, commtype: $commType, first: $first, offset: $offset) {\n    totalCount\n    ...CommunicationsList_al\n  }\n}\n\nfragment CommunicationsList_al on CommtEntriesConnection {\n  nodes {\n    commId\n    commType\n    destinationAccountId\n    destinationAccountType\n    destinationAccountName\n    destinationUserId\n    destinationAddress\n    destinationFirstname\n    destinationLastname\n    sendingAccountId\n    sendingAppId\n    customerAppId\n    notificationId\n    forwardingEmail\n    commSubject\n    sentTime\n  }\n}\n"
  }
};
})();

node.hash = "ba248d4b2cb6da052468b1c5fb1a0a66";

module.exports = node;
